"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _AccordionIcon = _interopRequireDefault(require("./AccordionIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Header = _styledComponents["default"].div.attrs(function () {
  return {
    className: "d-flex justify-content-between"
  };
}).withConfig({
  displayName: "AccordionHeader__Header",
  componentId: "sc-1hnlio0-0"
})(["&&&{width:100%;background-color:", ";color:", ";&:hover{cursor:pointer;}border:1px solid rgba(0,0,0,0.125);border-bottom:", ";border-radius:0;}"], function (props) {
  return props.styles.backgroundColor;
}, function (props) {
  return props.styles.color;
}, function (props) {
  return "1px solid " + props.styles.borderBottomColor;
});

var ChildrenWrapper = _styledComponents["default"].div.withConfig({
  displayName: "AccordionHeader__ChildrenWrapper",
  componentId: "sc-1hnlio0-1"
})(["width:100%;padding:", ";"], function (props) {
  return props.padding ? "0.75rem" : "0";
});

var DefaultHeaderStyle = {
  backgroundColor: "#ffffff",
  color: "#000000",
  borderBottomColor: "rgba(0, 0, 0, 0.125)"
};

var AccordionHeader = function AccordionHeader(_ref) {
  var styles = _ref.styles,
      children = _ref.children,
      _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? true : _ref$padding,
      _ref$isToggle = _ref.isToggle,
      isToggle = _ref$isToggle === void 0 ? false : _ref$isToggle,
      _ref$isOpen = _ref.isOpen,
      isOpen = _ref$isOpen === void 0 ? false : _ref$isOpen,
      onClick = _ref.onClick,
      _ref$hasCustomActionB = _ref.hasCustomActionButton,
      hasCustomActionButton = _ref$hasCustomActionB === void 0 ? false : _ref$hasCustomActionB,
      customActionButton = _ref.customActionButton,
      _ref$iconLeft = _ref.iconLeft,
      iconLeft = _ref$iconLeft === void 0 ? false : _ref$iconLeft,
      rest = _objectWithoutProperties(_ref, ["styles", "children", "padding", "isToggle", "isOpen", "onClick", "hasCustomActionButton", "customActionButton", "iconLeft"]);

  var CompStyles = _objectSpread({}, DefaultHeaderStyle, {}, styles);

  return _react["default"].createElement(Header, _extends({
    styles: CompStyles
  }, rest, {
    bottom: hasCustomActionButton || isToggle,
    onClick: isToggle ? onClick : undefined
  }), isToggle && iconLeft && _react["default"].createElement(_AccordionIcon["default"], {
    isOpen: isOpen
  }), _react["default"].createElement(ChildrenWrapper, {
    padding: padding
  }, children), hasCustomActionButton && customActionButton, isToggle && !iconLeft && _react["default"].createElement(_AccordionIcon["default"], {
    isOpen: isOpen
  }));
};

AccordionHeader.propTypes = {
  /** If the header has padding */
  padding: _propTypes["default"].bool,

  /** If the header is the toggle */
  isToggle: _propTypes["default"].bool,

  /** If the header is open */
  isOpen: _propTypes["default"].bool,

  /** OnClick reference - this is maintained by the accordion wrapper */
  onClick: _propTypes["default"].func,

  /** If the header has a custom action button */
  hasCustomActionButton: _propTypes["default"].bool,

  /** The custom action button to display */
  customActionButton: _propTypes["default"].oneOfType([_propTypes["default"].element, _propTypes["default"].object]),

  /** Custom styles object for accordion header */
  styles: _propTypes["default"].shape({
    backgroundColor: _propTypes["default"].string,
    color: _propTypes["default"].string,
    borderBottomColor: _propTypes["default"].string
  }),

  /** Move caret icon to the left side */
  iconLeft: _propTypes["default"].bool,

  /** Children to display */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};
AccordionHeader.defaultProps = {
  styles: DefaultHeaderStyle,
  isOpen: false,
  padding: true,
  isToggle: false,
  hasCustomActionButton: false,
  iconLeft: false,
  onClick: function onClick() {},
  customActionButton: null
};
AccordionHeader.displayName = "Header";
var _default = AccordionHeader;
exports["default"] = _default;